export enum VtmnPlayButtonVariantEnum {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  TERTIARY = 'tertiary',
  NEGATIVE = 'negative',
}
